import callApi from "res-api-cli/build/callApi";

/**
 * `PUT /sessions` — renew the session.
 *
 * CD-8740: takes **no request body**. The refresh token lives in the HttpOnly
 * `access_refresh` cookie, which the browser attaches automatically because
 * `callApi` sends `credentials: 'include'`.
 *
 * This doubles as the boot session probe: 200 means "signed in, here is the
 * user"; 401 means "not signed in".
 *
 * @param {object} opts callApi options — e.g. `fetcher` in tests, or `onError`
 *   to handle failure locally instead of via the global navigation handler.
 */
export default (opts = {}) =>
  callApi({
    ...opts,
    method: "PUT",
    url: "/sessions"
  });
